// Display-only escape for rejected imports or older records. Never mutate the stored value,
// digest, submitted draft or permission projection to make unsafe content appear accepted.
const unsafeReviewFormatting = /\p{Default_Ignorable_Code_Point}|(?![\t\n\r])\p{Cc}/gu;

export function isSafeReviewText(value: string, singleLine = false): boolean {
  return !(
    singleLine
      ? /[\p{Cc}\p{Default_Ignorable_Code_Point}]/u
      : /\p{Default_Ignorable_Code_Point}|(?![\t\n\r])\p{Cc}/u
  ).test(value);
}

export function reviewTextForDisplay(value: string): string {
  return value.replace(
    unsafeReviewFormatting,
    (character) => `[U+${character.codePointAt(0)?.toString(16).toUpperCase().padStart(4, "0")}]`,
  );
}
